module.exports = __webpack_public_path__ + "06_long_brown.1a757db6.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/aoyama/mom/layer5/06_long_brown.png
// module id = zNgj
// module chunks = 0